import { AxiosPostUrl } from "../../functions/axiosfunctions";

export function sendReferantSignupData(data: Object, cb = function (reponse: any) {}) {
  // console.log(data)
  AxiosPostUrl(
    "/administration/client/referant/new",
    data,
    (reponse) => {
      if (reponse) {
        cb(reponse);
      } else {
        cb({
          success: false,
          data: {},
          msg: "Erreur survenue !",
        });
      }
    },
    function (reponse) {
      cb({
        success: false,
        data: {},
        msg: "Erreur survenue !",
      });
    }
  );
}
